export default __webpack_public_path__ + "static/media/boschLogo.639dcbc0.png";